import { Fragment } from 'react'

import PropTypes from 'prop-types'

import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import AuthBackground from './background'
import AuthModal from './modal'

const Auth = ({ title, children, onSubmit }) => {
  const theme = useTheme()
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'))

  const AuthWrapper = isSmUp ? AuthBackground : Fragment

  return (
    <AuthWrapper>
      <AuthModal title={title} onSubmit={onSubmit}>
        {children}
      </AuthModal>
    </AuthWrapper>
  )
}

Auth.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default Auth
